@if (parada) {
  <div class="column-center" style="gap: 3px; width: 100%">
    <div class="row-space-between" style="width: 100%">
      <span
        tooltip="Hasta"
        style="cursor: default; font-size: 16px"
        class="material-icons"
      >
        event
      </span>
      <span>{{ parada.endTime | date: 'short' }}</span>
    </div>
    @if (parada.duration) {
      <div class="row-space-between" style="width: 100%">
        <span
          tooltip="Duración"
          style="cursor: default; font-size: 16px"
          class="material-icons"
        >
          timer
        </span>
        <!-- Tripero devuelve duración en segundos -->
        <span>{{ this.helper.parseSeconds(parada.duration) }}</span>
      </div>
    }
  </div>
}
